<template>
  <div class="container">
    <div class="form">
      <h3>手机号码验证</h3>
      <div class="input-group">
        <div class="group-item">
          <input type="text" placeholder="负责人手机号" v-model="form.phone" @input="onInputPhone" class="input-val" />
          <div class="error-msg" v-if="!isCheckPhone && form.phone">请输入正确的手机号</div>
        </div>
        <template v-if="isQuick!=1">
          <div class="group-item img-code-cont">
            <input
              v-model="form.imgCode"
              maxlength="4"
              auto-complete="off"
              placeholder="验证码"
              @input="onInputImgCode"
              style="width: 63%"  />
            <div class="login-code">
              <img :src="codeUrl" @click="getCodeImg" class="login-code-img"/>
            </div>
          </div>
          <div class="group-item group-item-code" v-if="!isCheckPhone || !form.imgCode">
              <input type="text" placeholder="请输入验证码" disabled class="input-val" />
              <div class="code-btn" style="opacity: 0.7;">获取验证码</div>
          </div>
          <div class="group-item group-item-code" v-else>
              <input type="text" placeholder="请输入验证码" maxlength="4" v-model="form.code" @input="onInputCode" class="input-val" />
              <div class="code-btn" @click="getCode" v-if="seconds == ''">获取验证码</div>
              <div class="code-btn" v-else>{{seconds}}</div>
          </div>
          <!-- <div class="group-item-link">
            <router-link :to="{path: '/set-password', query: { 'phone': form.phone}}">收不到验证码?</router-link>
          </div> -->
        </template>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer" v-if="isQuick!=1">
      <div class="submit-btn disabled-btn" v-if="!form.phone || !form.code || !isCheckPhone">下一步</div>
      <div class="submit-btn" @click="onSubmit" v-else>下一步</div>
    </div>
    <div class="footer" v-else>
      <div class="submit-btn disabled-btn" v-if="!form.phone">下一步</div>
      <div class="submit-btn" @click="onSubmit" v-else>下一步</div>
    </div>
    <ContactBtn />
  </div>
</template>

<script>
import store from '../store';
import { getCode, getCodeImg } from '@/api/user';
import { getToken, setQuickToken,getQuickToken,removeQuickToken } from '@/utils/auth'
import { getShopList, getPropertyList} from '@/api/baseinfo';

export default {
  name: 'login',
  data() {
    return {
      isQuick: sessionStorage.getItem('isQuick')||0,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      token: getToken(),
      isCheckPhone: false,
      isCheckCode: false,
      codeUrl: undefined,  // 验证图片地址
      // 验证码开关
      captchaOnOff: true,
      form: {
        phone: undefined,
        code: undefined,
        imgCode: undefined, // 验证图片
        uuid: undefined,
      },
      seconds: '',
      count: 60,
      timer: null,
    };
  },
  created() {
    if(this.$route.query.phone) {
      this.form.phone = this.$route.query.phone || undefined;
      this.isCheckPhone = this.checkPhone(this.form.phone);
    } else {
      sessionStorage.removeItem('phone');
    }
    if(this.$route.query.userAscription) {
      this.form.userAscription = this.$route.query.userAscription;
    } else {
      sessionStorage.removeItem('userAscription');
    }
    if(this.$route.query.quickAccessToken) {
      setQuickToken(this.$route.query.quickAccessToken)
      store.commit('SET_QUICK_TOKEN', this.$route.query.quickAccessToken);
    } else {
      removeQuickToken()
    }
    if(this.$route.query.isQuick) {
      this.isQuick = Number(this.$route.query.isQuick);
      if(this.isQuick<1){
        this.getCodeImg();
      }
    }else{
      this.getCodeImg();
      sessionStorage.removeItem('isQuick');
    }
    if(!this.$route.query.isVip) {
      sessionStorage.removeItem('isVip');
      sessionStorage.removeItem('vipShopCode');
    }
  },
  methods: {
    onInputPhone(val) {
      this.form.phone = this.trimSpecial(this.form.phone).substr(0,11);
      this.isCheckPhone = this.checkPhone(this.form.phone);
    },
    onInputImgCode() {
      // this.form.imgCode = this.form.imgCode.substr(0,4);
    },
    onInputCode(val) {
      this.form.code = this.checkNumber(this.form.code).substr(0,4);
    },
    getCodeImg() {
      getCodeImg().then(res => {
        this.captchaOnOff = res.captchaOnOff === undefined ? true : res.captchaOnOff;
        if (this.captchaOnOff) {
          this.codeUrl = "data:image/gif;base64," + res.img;
          this.form.uuid = res.uuid;
        }
      });
    },
    getCode() {
      const TIME_COUNT = 60;
      getCode(this.form).then(res => {
        if(res.code == 200) {
          setTimeout(() => {
            this.Toast('验证码已发送');
          }, 1500);
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
                this.seconds = 0 < this.count&&this.count < 10 ? '0'+this.count+'s' : this.count+'s';
              } else {
                clearInterval(this.timer);
                this.seconds = '';
                this.timer = null;
              }
            }, 1000)
          }
        } else {
          this.Toast(res.msg);
        }
      });
    },
    getShopList() {
      getShopList().then(res => {
        this.$router.push({
          path: '/store-list'
        })
        // if(res.data && res.data.length > 0) {
        //   this.$router.push({
        //     path: '/store-list'
        //   })
        //   if(res.data.length > 1) {
        //     this.$router.push({
        //       path: '/store-list'
        //     })
        //   } else {
        //     let data = res.data[0];
        //     if(data.shopStatus == 1030 || data.shopStatus == 1032) {
        //       this.$router.push({
        //         path: '/industry-info?shopCode=' + this.shopCode
        //       })
        //     } else if(data.shopStatus == 1050) {
        //       this.$router.push({
        //         path: '/apply-package?shopCode=' + this.shopCode
        //       })
        //     } else if(data.shopStatus == 1070) {
        //       this.$router.push({
        //         path: '/payment?shopCode=' + this.shopCode
        //       })
        //     } else if(data.shopStatus == 1090) {
        //       this.$router.push({
        //         path: '/baseinfo-auth?shopCode=' + this.shopCode
        //       })
        //     } else if(data.shopStatus == 1110 || data.shopStatus == 1130 || data.shopStatus == 1131 || data.shopStatus == 1132) {
        //       this.$router.push({
        //         path: '/apply-results?shopCode=' + this.shopCode
        //       })
        //     } else if(data.shopStatus == 2001) {
        //       this.$router.push({
        //         path: '/apply-passed?shopCode=' + this.shopCode
        //       })
        //     }
        //   }
        // } else {
        //   this.$router.push({
        //     path: '/industry-info'
        //   })
        // }
      })
    },
    onSubmit() {
      if(this.isQuick!=1){
        this.$store.dispatch("Login", this.form).then((res) => {
          this.getShopList();
          sessionStorage.removeItem('phone');
          sessionStorage.removeItem('userAscription');
        }).catch((err) => {
          this.getCodeImg();
          this.$toast(err.msg)
        });
      } else {
        this.$store.dispatch("agentLogin", this.form).then((res) => {
          this.getShopList();
          sessionStorage.removeItem('phone');
          sessionStorage.removeItem('userAscription');
        }).catch((err) => {
          console.log(err)
          this.$toast(err.msg)
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
  }
  .form{
    width: 100%;
    margin-top: 3rem;
    h3{
      line-height: 1;
      font-size: 1.2rem;
      color: #222;
      text-align: center;
    }
    .input-group{
      width: 15rem;
      margin: 4.25rem auto 0;
    }
    .group-item{
      width: 15rem;
      height: 2.8rem;
      margin-bottom: 1.2rem;
      border-radius: .5rem;
      border: 1px solid #ddd;
      &:focus{ 
        border: 1px solid $base-color;
      }
      input{
        width: 100%;
        height: 1.4rem;
        line-height: 1.4rem;
        margin: 0.7rem 0;
        padding: 0 .65rem;
        border: 0;
        box-sizing: border-box;
        outline: none;
        // height:  2.8rem;
        // line-height: 2.8rem;
        // border-radius: .5rem;
        // border: 1px solid #ddd;
        @include flex();
        font-size: .8rem;
        color: #222;
        background: #fff;
        &::-webkit-input-placeholder {
            font-size: .8rem;
            color: #ccc;
        }
        :-moz-placeholder {
            font-size: .8rem;
            color: #ccc;
        }
        ::-moz-placeholder {
            font-size: .8rem;
            color: #ccc;
        }
        // &[type="text"]:focus{ 
        //   border: 1px solid $base-color;
        // }
      }
      .code-btn{
        font-size: .6rem;
        color: #47B6C7;
        text-align: right;
      }
    }
    .img-code-cont{
      display: flex;
      align-items: center;
      .login-code {
        width: 36%;
        height: 38px;
        // margin-top: 10px;
        float: right;
        display: flex;
        justify-content: flex-end;
        .login-code-img {
          width: 90%;
          height: 38px;
          vertical-align: middle;
          cursor: pointer;
          margin: 0 auto;
          // padding: 0 .65rem;
        }
      }
    }
    .group-item-code{
      position: relative;
      margin-bottom: .5rem;
      input{
        width: 15rem;
        padding-right: 4.5rem;
        box-sizing: border-box;
      }
      .code-btn{
        height: 2.6rem;
        position: absolute;
        right: .65rem;
        top: 0;
        z-index: 3;
        cursor: pointer;
        @include flex-align();
      }
    }
    .group-item-link{
      line-height: 1.4;
      text-align: right;
      a{
        font-size: .6rem;
        color: #999;
      }
    }
  }
  .error-msg{
    line-height: 1.1rem;
    font-size: .65rem;
    color: #FF4743;
  }
}
@media screen and (min-width:750px){
  .form{
    width: 100%;
    margin-top: 60px;
    h3{
      line-height: 1;
      font-size: 24px;
      color: #222;
      text-align: center;
    }
    .input-group{
      width: 300px;
      margin: 85px auto 0;
    }
    .group-item{
      width: 300px;
      height: 56px;
      margin-bottom: 24px;
      border-radius: 10px;
      border: 1px solid #ddd;
      &:focus{ 
        border: .100px solid $base-color;
      }
      input{
        width: 100%;
        height: 28px;
        line-height: 28px;
        margin: 14px 0;
        padding: 0 13px;
        border: 0;
        box-sizing: border-box;
        outline: none;
        // height:  56px;
        // line-height: 56px;
        // border-radius: 10px;
        // border: 1px solid #ddd;
        @include flex();
        font-size: 16px;
        color: #222;
        background: #fff;
        &::-webkit-input-placeholder {
            font-size: 16px;
            color: #ccc;
        }
        :-moz-placeholder {
            font-size: 16px;
            color: #ccc;
        }
        ::-moz-placeholder {
            font-size: 16px;
            color: #ccc;
        }
        // &[type="text"]:focus{ 
        //   border: 1px solid $base-color;
        // }
      }
      .code-btn{
        font-size: 12px;
        color: #47B6C7;
        text-align: right;
      }
    }
    .img-code-cont{
      display: flex;
      align-items: center;
      .login-code {
        width: 36%;
        height: 38px;
        // margin-top: 10px;
        float: right;
        display: flex;
        justify-content: flex-end;
        .login-code-img {
          width: 90%;
          height: 38px;
          vertical-align: middle;
          cursor: pointer;
          margin: 0 auto;
        }
      }
    }
    .group-item-code{
      position: relative;
      margin-bottom: 10px;
      input{
        width: 300px;
        padding-right: 90px;
        box-sizing: border-box;
      }
      .code-btn{
        height: 52px;
        position: absolute;
        right: 13px;
        top: 0;
        z-index: 3;
        cursor: pointer;
        @include flex-align();
      }
    }
    .group-item-link{
      line-height: 1.4;
      text-align: right;
      a{
        font-size: 12px;
        color: #999;
      }
    }
  }
  .error-msg{
    line-height: 22px;
    font-size: 13px;
    color: #FF4743;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue